import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';



export function  requiredTrimmed(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (typeof value === 'string' && value.trim().length === 0) {
                return {required: true};
            }
            return null;
        };

    }

export function  requiredNumberPattern(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (typeof value === 'string' && !value.trim().match('^[0-9]*$')) {
                return {pattern: true};
            }
            return null;
        }
    }

export function   emailValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }
            const emailRegex = /^(?!\.)(?!.*\.{2,})[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const valid = emailRegex.test(control.value);
            return valid ? null : {email: true};
        };
    }

